<pmt-action-modal
  [title]="'Einsätze'"
  [onlyCancel]="true"
  [cancelButtonText]="'Close'"
>
  <!-- Body of the modal -->
  <h4>ID: {{ assignment.id }}</h4>
</pmt-action-modal>
